import LoyaltyDropView from "@/views/LoyaltyDropView.vue";

const boostRoutes = {
  path: '/boost',
  name: 'boost',
  component: LoyaltyDropView,
};
export default boostRoutes;
